'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import 'I18n/init/setup/BasicPublicI18nSetup';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { RhumbProvider } from 'react-rhumb';
import UIApplication from 'UIComponents/app/UIApplication';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import configureStore from './utils/configureStore';
import rhumbConfig from '../rhumb-config.yaml';
import Routes from './components/Routes';
import { startApp } from './actions/AppActions';
import { getRootUrl } from './utils/urls';
export default class App {
  start() {
    setDocumentTitle('app.htmlTitle');
    this.startRedux();
    this.startRouter();
  }

  startRedux() {
    this.store = configureStore();
    this.store.dispatch(startApp());
  }

  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    render( /*#__PURE__*/_jsx(UIApplication, {
      name: "khoros-integration-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: rhumbConfig,
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(Routes, {})
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}